/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Motasim Kazmi",
  title: "Hi all, I'm Motasim Kazmi",
  subTitle: emoji(
    "A passionate Full Stack Software Engineer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1Ph04-QNKRc8w_d2zNs-O9ZNW-NOunVvM/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/mrkazmi333",
  linkedin: "https://www.linkedin.com/in/mrk333/",
  gmail: "motasimkazmi333@gmail.com",
  facebook: "https://www.facebook.com/motasim.kazmi",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji("⚡ Integration of third party services such as Firebase/ AWS ")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "mongo-db",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Jamia Hamdard",
      logo: require("./assets/images/jamiaHamdardLogo.png"),
      subHeader: "Bachelor of Technology in Computer Science and Engineering",
      duration: "July 2016 - October 2020",
      desc: "Studied subjects related to Computer Science and IT.",
      descBullets: [
        "Participated in various college Tech Fests and events",
        "Organized Programming Bootcamps and taught Coding to School kids as part of Code.org week"
      ]
    },
    {
      schoolName: "Oriental College",
      logo: require("./assets/images/orientalCollegeLogo.png"),
      subHeader: "Intermediate in Science (I.Sc) in Maths",
      duration: "June 2013 - March 2015",
      desc:
        "Completed my Higher Schooling here with subject including Physics, Chemistry and Maths."
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Development Engineer 1",
      company: "Idiosnow Works Pvt Ltd",
      companylogo: require("./assets/images/idiosnowLogo.jpg"),
      date: "November 2020 – Present",
      desc:
        "Responsible for building the complete frontend of the Web Application.",
      descBullets: [
        "Tech Stacks used- Javascript, ReactJs, Redux, HTML,CSS, MaterialUI,"
      ]
    },
    {
      role: "Web Development Intern",
      company: "Bytesbrick Infosystems Pvt Ltd",
      companylogo: require("./assets/images/bytesBrickLogo.png"),
      date: "Aug 2019 – Nov 2019",
      desc: "Improved the recommendation system for a Pet eCommerce website.",
      descBullets: ["Tech Stacks used- MySQL, Python, Django"]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "mrkazmi333", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME PROJECTS THAT I DID",
  projects: [
    {
      image: require("./assets/images/ecomShop.png"),
      projectName: "Ecom Shop",
      projectDesc:
        "A complete E-commerce website with Admin Panel, Front-End and Backend built using ReactJs/NodeJs/MongoDB and more",
      footerLink: [
        {
          name: "Visit Website",
          url: ""
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/idiosPage.png"),
      projectName: "Idiosnow",
      projectDesc:
        "World's 1st Personality And Skill Development Programme For Kids",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://idiosnow.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Additional Details and Volunteering 🏆 "),
  subtitle:
    "Achievements, Certifications, Volunteering, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Intel Software Innovator",
      subtitle:
        "Software Innovator program is a community developer program from Intel Corporation which provides speaking and demonstration opportunities for innovative, independent developers..",
      image: require("./assets/images/intelSoftwareInnovatorLogo.webp"),
      footerLink: [
        {
          name: "Innovator Profile",
          url: "https://devmesh.intel.com/users/motasim-kazmi"
        }
      ]
    },
    {
      title: "NumFocus PyData Global Organising Committee",
      subtitle:
        "Responsible for Organising PyData Global 2020, which was a fully online virtual conference involving speakers and attendees from around the world.",
      image: require("./assets/images/pyDataGlobalLogo.png"),
      footerLink: [
        {
          name: "View Website",
          url: "https://global.pydata.org/pages/organizers"
        }
      ]
    },

    {
      title: "PyData Delhi Core Team Member",
      subtitle:
        "Helps in organising the PyData Delhi annual conference and monthly PyData Delhi meetups.",
      image: require("./assets/images/pyDataDelhiLogo.png"),
      footerLink: [
        {name: "Visit Website", url: "https://pydata.org/delhi2019/"}
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url:
        "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Recommendation Engine For E-Commerce",
      subtitle: "PyData Delhi November 2019 Meetup, Atlan HQ, New Delhi",
      slides_url:
        "https://docs.google.com/presentation/d/1196o_yNAg54tbhI2GZqgCf2v98xvS4uk/edit#slide=id.p1",
      event_url: "https://www.meetup.com/PyDataDelhi/events/266436797/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-8804223700",
  emailAddress: "motasimkazmi333@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "KazmiMotasim", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
